import React from 'react';
import { motion } from 'framer-motion';
import { PORTAL_MARK_SVG } from '../../assets/portalMark';

/**
 * THE SIGN-OFF — the last thing on a finished project's page.
 *
 * Tom: *"We need an exciting sign off at the end - perhaps our contact or
 * our logo - just something."* The page used to stop dead on the last
 * bullet of the 2027 plan, which reads like a document that ran out rather
 * than a studio handing something over.
 *
 * THE MARK IS RECOLOURED, NOT RECUT. `portalMark.ts` carries the whole
 * 244.17 square with its own rounded corners; its artwork colour `#333` is
 * swapped for `currentColor` so it inherits paper on ink. Three earlier
 * attempts at the app icon were cropped out of the LOCKUP file and put
 * "Por" on Shilpa's home screen — nothing here crops it.
 *
 * NO INVENTED CONTACT DETAILS. The name and role come from the project's
 * own team; an email address that nobody checks is worse than none.
 */

const EASE = [0.22, 1, 0.36, 1] as const;
const MARK = PORTAL_MARK_SVG.replace('#333', 'currentColor').replace('<svg ', '<svg width="100%" height="100%" ');
export function SignOff({
  lead
}: {
  lead?: {
    name: string;
    role: string;
  };
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.6,
    ease: EASE
  }} className="mt-24 flex flex-col items-center bg-ink px-8 py-20 text-center text-paper sm:py-24" data-id="element-245" data-mp="2vtzdy83jw4ko">
      <motion.span aria-hidden initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.7,
      ease: EASE,
      delay: 0.1
    }} className="block h-14 w-14 text-paper" dangerouslySetInnerHTML={{
      __html: MARK
    }} data-id="element-246" data-mp="284n4d74b9uhu" />

      <p className="mt-10 m-0 font-display text-4xl font-light leading-none tracking-tight sm:text-5xl" data-id="element-247" data-mp="1kestuw7gsi0r">
        Thank you
      </p>

      <p className="label mt-8 m-0 text-paper/55" data-id="element-248" data-mp="1hdpr78a0bsjh">Portal Productions</p>

      {lead && <div className="mt-10 border-t border-paper/20 pt-8" data-id="element-249" data-mp="1hbd0o6q6o9ut">
          <p className="m-0 text-[1.05rem] text-paper" data-id="element-250" data-mp="1dbchy9w1xchy">{lead.name}</p>
          <p className="mt-1.5 m-0 text-[0.9rem] text-paper/55" data-id="element-251" data-mp="1r3sgoyhx6od2">{lead.role}</p>
        </div>}
    </motion.div>;
}